export default {"src":"/_next/static/media/app-store_badge_he.1dd7c76e.svg","height":40,"width":120};